export const sections = [
  "Revenue",
  "Other Income",
  "Cost of Sales",
  "Expenses",
];

export const taxAdjustmentOptions = [
  // Basic Options
  { value: "", label: "None", group: "Basic Options" },
  { value: "Added Back", label: "Added Back", group: "Basic Options" },
  { value: "Deduct", label: "Deduct", group: "Basic Options" },

  // Breakdown Schedules
  {
    value: "Partial Breakdown Schedule",
    label: "Partial Breakdown Schedule",
    group: "Breakdown Schedules",
  },
  {
    value: "Full Breakdown Schedule",
    label: "Full Breakdown Schedule",
    group: "Breakdown Schedules",
  },

  // Income Schedules
  {
    value: "Other Income Schedule",
    label: "Other Income Schedule",
    group: "Income Schedules",
  },
  {
    value: "Rental Schedule",
    label: "Rental Income Schedule",
    group: "Income Schedules",
  },

  // Foreign Income Schedules
  {
    value: "Foreign Trade / Branch Schedule",
    label: "Foreign Trade / Branch Schedule",
    group: "Foreign Income Schedules",
  },
  {
    value: "Unremitted Foreign Income Tracking Schedule",
    label: "Unremitted Foreign Income Tracking Schedule",
    group: "Foreign Income Schedules",
  },
  {
    value: "Foreign Tax Credit Schedule",
    label: "Foreign Tax Credit Schedule",
    group: "Foreign Income Schedules",
  },

  // Deduction Schedules
  {
    value: "Further Deduction Schedule",
    label: "Further Deduction Schedule",
    group: "Deduction Schedules",
  },
  {
    value: "Share-Based Payment Schedule",
    label: "Share-Based Payment Schedule",
    group: "Deduction Schedules",
  },
  {
    value: "Interest Expense Schedule",
    label: "Interest Expense Schedule",
    group: "Deduction Schedules",
  },
  {
    value: "Medical Expense Schedule",
    label: "Medical Expense Schedule",
    group: "Deduction Schedules",
  },
  {
    value: "Donation Schedule",
    label: "Donation Schedule",
    group: "Deduction Schedules",
  },
  {
    value: "Renovation Schedule",
    label: "Renovation Schedule",
    group: "Deduction Schedules",
  },

  // Other Schedules
  {
    value: "Movement Schedule",
    label: "Movement Schedule",
    group: "Other Schedules",
  },
  {
    value: "FAAdditions",
    label: "FA Addition Schedule",
    group: "Other Schedules",
  },
  { value: "Savy Schedule", label: "Savy Schedule", group: "Other Schedules" },
];

export const taxAdjustmentOptions_tagging = [
  // Basic Options
  { value: "", label: "None", group: "Basic Options" },
  { value: "Added Back", label: "Added Back", group: "Basic Options" },
  { value: "Deduct", label: "Deduct", group: "Basic Options" },

  // Breakdown Schedules
  {
    value: "Full Breakdown Schedule",
    label: "Full Breakdown Schedule",
    group: "Breakdown Schedules",
  },
  {
    value: "Partial Breakdown Schedule",
    label: "Partial Breakdown Schedule",
    group: "Breakdown Schedules",
  },

  // Income Schedules
  {
    value: "Other Income Schedule",
    label: "Other Income Schedule",
    group: "Income Schedules",
  },
  {
    value: "Rental Schedule",
    label: "Rental Income Schedule",
    group: "Income Schedules",
  },

  // Foreign Income Schedules
  {
    value: "Foreign Trade / Branch Schedule",
    label: "Foreign Trade / Branch Schedule",
    group: "Foreign Income Schedules",
  },

  // Deduction Schedules
  {
    value: "Donation Schedule",
    label: "Donation Schedule",
    group: "Deduction Schedules",
  },
  {
    value: "Further Deduction Schedule",
    label: "Further Deduction Schedule",
    group: "Deduction Schedules",
  },
  {
    value: "Interest Expense Schedule",
    label: "Interest Expense Schedule",
    group: "Deduction Schedules",
  },
  {
    value: "Medical Expense Schedule",
    label: "Medical Expense Schedule",
    group: "Deduction Schedules",
  },
  {
    value: "Renovation Schedule",
    label: "Renovation Schedule",
    group: "Deduction Schedules",
  },
  {
    value: "Share-Based Payment Schedule",
    label: "Share-Based Payment Schedule",
    group: "Deduction Schedules",
  },

  // Other Schedules
  {
    value: "FAAdditions",
    label: "FA Addition Schedule",
    group: "Other Schedules",
  },
  {
    value: "Movement Schedule",
    label: "Movement Schedule",
    group: "Other Schedules",
  },
  { value: "Savy Schedule", label: "Savy Schedule", group: "Other Schedules" },
];

export const investmentTaxAdjustmentOptions = [
  // Basic Options
  { value: "", label: "None", group: "Basic Options" },
  { value: "Added Back", label: "Added Back", group: "Basic Options" },
  { value: "Deduct", label: "Deduct", group: "Basic Options" },

  // Income Schedules
  {
    value: "Other Investment Income Schedule",
    label: "Other Income Schedule",
    group: "Income Schedules",
  },
  {
    value: "Rental Schedule",
    label: "Rental Income Schedule",
    group: "Income Schedules",
  },
  {
    value: "Service Income Schedule",
    label: "Service Income Schedule",
    group: "Income Schedules",
  },

  // Foreign Income Schedules
  {
    value: "Foreign Tax Credit Schedule",
    label: "Foreign Tax Credit Schedule",
    group: "Foreign Income Schedules",
  },
  {
    value: "Unremitted Foreign Income Tracking Schedule",
    label: "Unremitted Foreign Income Tracking Schedule",
    group: "Foreign Income Schedules",
  },

  // Deduction Schedules
  {
    value: "Allocation Of Expenses",
    label: "Allocation Of Expenses",
    group: "Deduction Schedules",
  },
  {
    value: "Donation Schedule",
    label: "Donation Schedule",
    group: "Deduction Schedules",
  },
  {
    value: "Share-Based Payment Schedule",
    label: "Share-Based Payment Schedule",
    group: "Deduction Schedules",
  },

  // Breakdown Schedules
  {
    value: "Full Breakdown Schedule",
    label: "Full Breakdown Schedule",
    group: "Breakdown Schedules",
  },
  {
    value: "Partial Breakdown Schedule",
    label: "Partial Breakdown Schedule",
    group: "Breakdown Schedules",
  },

  // Other Schedules
  { value: "Savy Schedule", label: "Savy Schedule", group: "Other Schedules" },
];

export const investmentTaxAdjustmentOptions_tagging = [
  // Keep basic actions first; sort schedule names alphabetically within each group.
  // Basic Options
  { value: "", label: "None", group: "Basic Options" },
  { value: "Added Back", label: "Added Back", group: "Basic Options" },
  { value: "Deduct", label: "Deduct", group: "Basic Options" },

  // Income Schedules
  {
    value: "Other Investment Income Schedule",
    label: "Other Income Schedule",
    group: "Income Schedules",
  },
  {
    value: "Rental Schedule",
    label: "Rental Income Schedule",
    group: "Income Schedules",
  },
  {
    value: "Service Income Schedule",
    label: "Service Income Schedule",
    group: "Income Schedules",
  },

  // Deduction Schedules
  {
    value: "Donation Schedule",
    label: "Donation Schedule",
    group: "Deduction Schedules",
  },
  {
    value: "Share-Based Payment Schedule",
    label: "Share-Based Payment Schedule",
    group: "Deduction Schedules",
  },

  // Allocation Of Expenses
  {
    value: "Allocation of Expenses/Common Expenses",
    label: "Common Expenses",
    group: "Allocation Of Expenses",
  },
  {
    value: "Allocation of Expenses/Statutory Expenses",
    label: "Statutory Expenses",
    group: "Allocation Of Expenses",
  },

  // Breakdown Schedules
  {
    value: "Full Breakdown Schedule",
    label: "Full Breakdown Schedule",
    group: "Breakdown Schedules",
  },
  {
    value: "Partial Breakdown Schedule",
    label: "Partial Breakdown Schedule",
    group: "Breakdown Schedules",
  },

  // Other Schedules
  { value: "Savy Schedule", label: "Savy Schedule", group: "Other Schedules" },
];

export const detailsPLSchedules = {
  "Savy Schedule": "Savy",
  "Partial Breakdown Schedule": "Partial Breakdown",
  "Full Breakdown Schedule": "Full Breakdown",
  "Rental Schedule": "Rental",
  "Further Deduction Schedule": "Further Deduction",
  "Share-Based Payment Schedule": "Share Based Payment",
  "Medical Expense Schedule": "Medical Expense",
  "Other Income Schedule": "Other Income",
  "Interest Expense Schedule": "Interest Expense",
  "Donation Schedule": "Donation",
  "Movement Schedule": "Movement",
  "Renovation Schedule": "Renovation",
  "Foreign Tax Credit Schedule": "Foreign Tax Credit",
  "Foreign Trade / Branch Schedule": "Foreign Trade",
  "Unremitted Foreign Income Tracking Schedule": "Unremitted_Foreign_Income",
  FAAdditions: "FAAdditions",
};

export const detailsPLSchedules_tagging = {
  "Savy Schedule": "Savy",
  "Partial Breakdown Schedule": "Partial Breakdown",
  "Full Breakdown Schedule": "Full Breakdown",
  "Rental Schedule": "Rental",
  "Further Deduction Schedule": "Further Deduction",
  "Share-Based Payment Schedule": "Share Based Payment",
  "Medical Expense Schedule": "Medical Expense",
  "Other Income Schedule": "Other Income",
  "Interest Expense Schedule": "Interest Expense",
  "Donation Schedule": "Donation",
  "Movement Schedule": "Movement",
  "Renovation Schedule": "Renovation",
  "Foreign Trade / Branch Schedule": "Foreign Trade",
  FAAdditions: "FAAdditions",
};

export const investmentDetailsPLSchedules = {
  "Savy Schedule": "Investment Savy",
  "Partial Breakdown Schedule": "Partial Breakdown",
  "Full Breakdown Schedule": "Full Breakdown",
  "Allocation Of Expenses": "Allocation Of Expenses",
  "Other Investment Income Schedule": "Other Investment Income",
  "Rental Schedule": "Rental",
  "Service Income Schedule": "Service Income",
  "Donation Schedule": "Donation",
  "Share-Based Payment Schedule": "Share Based Payment",
  "Foreign Tax Credit Schedule": "Foreign Tax Credit",
  "Unremitted Foreign Income Tracking Schedule": "Unremitted_Foreign_Income",
};

export const investmentDetailsPLSchedules_tagging = {
  "Savy Schedule": "Investment Savy",
  "Partial Breakdown Schedule": "Partial Breakdown",
  "Full Breakdown Schedule": "Full Breakdown",
  "Allocation Of Expenses": "Allocation Of Expenses",
  "Allocation of Expenses/Common Expenses":
    "Allocation of Expenses/Common Expenses",
  "Allocation of Expenses/Statutory Expenses":
    "Allocation of Expenses/Statutory Expenses",
  "Other Investment Income Schedule": "Other Investment Income",
  "Rental Schedule": "Rental",
  "Service Income Schedule": "Service Income",
  "Donation Schedule": "Donation",
  "Share-Based Payment Schedule": "Share Based Payment",
  "Foreign Tax Credit Schedule": "Foreign Tax Credit",
  FAAdditions: "FAAdditions",
};

export const getAdjustmentType = (scheduleType, scheduleDataMap) => {
  if (
    scheduleType === "Renovation" ||
    scheduleType === "FAAdditions" ||
    scheduleType === "Donation"
  ) {
    return "Added Back";
  }
  if (
    scheduleType !== "Rental" &&
    scheduleType !== "Other Income" &&
    scheduleType !== "Foreign Trade"
  ) {
    return "none";
  }

  const rowType = scheduleDataMap.rowType;

  const adjustmentRules = {
    Rental: {
      rental_gross_income: "Deduct",
      rental_expenses: "Added Back",
    },
    "Other Income": {
      other_income: "Deduct",
      other_income_expenses: "Added Back",
    },
    "Foreign Trade": {
      foreign_trade_revenue: "Deduct",
      foreign_trade_expenses: "Added Back",
    },
  };

  return adjustmentRules[scheduleType]?.[rowType] || "none";
};
